__turbopack_context__.v({
  "listingAddress": "listing-address-module-scss-module__hCi3BW__listingAddress",
  "listingAddress_divider": "listing-address-module-scss-module__hCi3BW__listingAddress_divider",
  "listingAddress_place": "listing-address-module-scss-module__hCi3BW__listingAddress_place",
});
